import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { setSubLoading } from "../../Redux/Services/AuthSlice";
import { NotificationSound } from "../CommonComponents/CommonNotification";
import { ApiCall, handleDateChange, initializeFilterData } from "../CommonComponents/CustomHooks";
import { CommonApiData } from "../CommonComponents/EnvConfig";
import { handleDownloadExcel } from "../CommonComponents/ExportData";
import { AutoCompleteBoxNew, DateBox, InputBox } from "../CommonComponents/InputBox";
import { Table } from "../CommonComponents/Table";

const SaleCancellationRequest = () => {
    const [currentPageNo, setCurrentPageNo] = useState(1);
    const dispatch = useDispatch();
    let [result, setResult] = useState([]);
    const [CheckAll, setCheckAll] = useState(false)
    const [sortConfig, setSortConfig] = useState({ SortColumn: null, SortOrder: null });
    const [loading, setLoading] = useState(false);
    const inputrefs = useRef([]);
    const [filterData, setFilterData] = useState(initializeFilterData)
    const commonData = CommonApiData();
    let pqrDate = new Date()
    let dateArr = pqrDate?.toString()?.split(' ')
    dateArr = `${dateArr[2]}-${dateArr[1]}-${dateArr[3]}`

    let Data = {
        "authToken": commonData.AuthToken,
        "loginToken": commonData.LoginToken,
        "userCode": commonData.UserCode,
    };
    const [formData, setFormData] = useState({
        ...Data,
        "UCode": "",
        "fromDate": dateArr,
        "toDate": dateArr,
        OnlinePaymentID: '',
        "FormName": "",
        "RefNo": "",
        "LogType": "",
        "ActionDescription": "",
    })

    const handleSorting = (SortColumn) => {
        let SortOrder = 'ASC';

        if (sortConfig && sortConfig.SortColumn === SortColumn && sortConfig.SortOrder === 'ASC') {
            SortOrder = 'DESC';
        }
        setSortConfig({ SortColumn, SortOrder });
    };

    const handleClear = () => {
        setFormData({
            ...formData,
            "UCode": "",
            "fromDate": dateArr,
            "toDate": dateArr,
            "FormName": "",
            "RefNo": "",
            "LogType": "",
            "ActionDescription": "",
        })
        filterData.SearchText = ''
        filterData.AdvanceFilter = []
        setSortConfig({ SortColumn: null, SortOrder: null })
        inputrefs.current['txtFromDate'].focus()
    }

    let PageName = 'SaleCancellationRequest'
    const handleChange1 = (event, value) => {
        GetSaleCancellationRequest(value);
    };


    const handleSubmit = async () => {
        await dispatch(setSubLoading(true))
        let data = await ApiCall(`/api/SalesEntryAPI/RefundTransaction`, { Type: 'SaleCancellation', OnlinePaymentID: (formData.OnlinePaymentID).toString() || '' })
        await dispatch(setSubLoading(false))
        await NotificationSound(data.status, data.message, data.focus, inputrefs, handleClear);
        
    };

    const GetSaleCancellationRequest = async (CurrentPage) => {
        let PageIndex = 1
        if (CurrentPage !== undefined && typeof (CurrentPage) !== "object") {
            PageIndex = CurrentPage;
            setCurrentPageNo(CurrentPage);
        }
        else {
            setCurrentPageNo(1);
        }
        let GetData = {
            ...formData,
            ...filterData,
            ...Data,
            ...sortConfig,
            "PageIndex": PageIndex.toString(),
            "Type": "S",
        }
        setLoading(true)
        let data = await ApiCall('/api/Report/SaleCancellationRequest', GetData)
        setLoading(false)
        if (data.Status === 'UNAUTHORIZED' || data.Status === 'EXPIRED' || data.Status === 'ERROR') {
            await NotificationSound(data.Status, data.Message, data.Focus, inputrefs);
        }
        setResult(data)
    }

    const handleCheck = (id, OnlinePaymentID, i) => {
        const updatedTableData = result?.Data.map((item, index) => {
            if (index === i) {
                return {
                    ...item,
                    checkStatus: !item.checkStatus
                };
            }
            return item;
        });
        setResult(prevResult => ({
            ...prevResult,
            Data: updatedTableData
        }));
        const updatedOnlinePaymentID = updatedTableData
            .filter(item => item.checkStatus)
            .map(item => item.Checkbox);

        setFormData({ ...formData, OnlinePaymentID: updatedOnlinePaymentID });
    };

    const handleCheckAll = (value) => {
        setCheckAll(value);
        const updatedTableData = result?.Data.map(item => {
            return {
                ...item,
                checkStatus: value
            };
        });
        setResult(prevOnlinePaymentID => ({
            ...prevOnlinePaymentID,
            Data: updatedTableData
        }));
        const updatedOnlinePaymentID = value ? result?.Data.map(item => item.Checkbox) : [];
        setFormData({ ...formData, OnlinePaymentID: updatedOnlinePaymentID });
    };

    let ExportRequest = {
        ...Data,
        ...formData,
        ...filterData,
        ...sortConfig,
        Type: 'E',
        PageIndex: '1'
    }
    useEffect(() => {
        inputrefs.current['txtFromDate'].focus()
        document.title = 'Sale Cancellation Request'
    }, [sortConfig]);

    return (
        <>
            <div className='main-card card border-0'>
                <div className='card-header mb-1'>
                    <h6 className="m-0">{'Sale Cancellation Request'}</h6>
                </div>
                <div className='card-body'>
                    <div className='row'>

                        <DateBox
                            id='txtFromDate'
                            required={true}
                            inputrefs={inputrefs}
                            label='From Date'
                            selected={formData.fromDate === '' ? '' : new Date(formData.fromDate)}
                            onChange={(e) => handleDateChange(e, setFormData, formData, 'fromDate')}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') { inputrefs.current['txtLogDateTo'].focus() };
                            }}

                        />
                        <DateBox
                            id='txtLogDateTo'
                            required={true}
                            inputrefs={inputrefs}
                            label='To Date'
                            selected={formData.toDate === '' ? '' : new Date(formData.toDate)}
                            onChange={(e) => handleDateChange(e, setFormData, formData, 'toDate')}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') { inputrefs.current['txtDealer'].focus() };
                            }}
                        />
                        <AutoCompleteBoxNew
                            id="txtDealer"
                            placeholder="Dealer"
                            label='Dealer'
                            inputrefs={inputrefs}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') { inputrefs.current['txtPolicyNo'].focus() };
                            }}
                            autocompleteType='GetDealerMaster'
                            value={formData?.UCode || ''}
                            onChange={async (event, newInputValue) => {
                                newInputValue = newInputValue || ''
                                if (event.type !== 'keydown') {
                                    setFormData({ ...formData, dealer: newInputValue })
                                }
                            }}
                            maxLength='50'
                        />

                        <InputBox
                            label='Policy No'
                            placeholder='Policy No'
                            inputrefs={inputrefs}
                            id='txtPolicyNo'
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') { inputrefs.current['txtbtn'].focus() };
                            }}
                            value={formData.policyNo}
                            onChange={(e) => setFormData({ ...formData, policyNo: e.target.value })}
                            autoComplete="off"
                        />
                    </div>
                    <div className='d-block mt-3 d-md-flex' >
                    
                        <button
                            ref={ref => (inputrefs.current[`btnSub`] = ref)}
                            onClick={handleSubmit}
                            className="btn btn-rounded btn-success">
                            <span className=" text-white me-2">
                                <i className="fa fa-save"></i>
                            </span>Save</button>
                        <button
                            ref={ref => (inputrefs.current[`txtbtn`] = ref)}
                            onClick={GetSaleCancellationRequest}
                            className="btn btn-rounded btn-primary">
                            <span className=" text-white me-2">
                                <i className="fa fa-search"></i>
                            </span>Search</button>
                        <button
                            className="btn btn-rounded btn-warning"
                            onClick={async () => {
                                try {
                                    dispatch(setSubLoading(true))
                                    await handleDownloadExcel('/api/Report/SaleCancellationRequest', ExportRequest, 'Sale Cancellation Request');
                                    dispatch(setSubLoading(false))
                                } finally {
                                    dispatch(setSubLoading(false))
                                }
                            }}
                        >
                            <span className="text-warning me-2">
                                <i className="fa fa-download text-white color-success"></i>
                            </span>
                            Export
                        </button>
                        <button onClick={handleClear} className="btn btn-rounded btn-danger"><span className="text-white me-2"><i className="fa-solid fa-arrow-rotate-left"></i>
                        </span>Reset</button>
                    </div>
                </div>
            </div>
            <Table
                PageName={PageName}
                loading={loading}
                handleFilter={() => {
                    GetSaleCancellationRequest();
                    setFilterData({
                        ...filterData,
                    })
                }}
                filterData={filterData}
                handleCheck={handleCheck}
                handleCheckAll={handleCheckAll}
                CheckAll={CheckAll}
                setFilterData={setFilterData}
                tableData={result}
                currentPageNo={currentPageNo}
                handleChange1={handleChange1}
                handleSorting={handleSorting}
                sortConfig={sortConfig}
                Filter={false}
                onlyFilterPage={true}
            />
        </>
    )
}
export default SaleCancellationRequest;